var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    width: 42.1428,
    height: 39.2857,
    rx: 10,
    fill: "#2F8AF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9718 24.0078C24.6606 24.319 24.1073 24.319 23.7961 24.0078L16.1885 16.4002C15.8773 16.089 15.8773 15.5357 16.1885 15.2245C16.3614 15.0516 16.5689 14.9825 16.7763 14.9825C16.9838 14.9825 17.1912 15.0516 17.3641 15.2245L20.58 18.4404L23.7959 15.2245C23.9688 15.0516 24.1763 14.9825 24.3837 14.9825C24.5912 14.9825 24.7986 15.0516 24.9715 15.2245C25.2828 15.5357 25.2828 16.089 24.9715 16.4002L21.7556 19.6161L24.9715 22.8321C25.2827 23.1432 25.2827 23.6619 24.9714 24.0077L24.9718 24.0078Z",
    fill: "#2F8AF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3643 24.0078C17.053 24.319 16.4998 24.319 16.1885 24.0078C15.8773 23.6965 15.8773 23.1433 16.1885 22.832L18.0213 20.9993C18.1942 20.8264 18.4016 20.7572 18.6091 20.7572C18.8166 20.7572 19.024 20.8264 19.1969 20.9993C19.5081 21.3105 19.5081 21.8637 19.1969 22.175L17.3643 24.0078Z",
    fill: "#2F8AF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.333 30.1973H10.83C10.3804 30.1973 10.0001 29.8169 10.0001 29.3673V13.7719C10.0001 13.3223 10.3804 12.9419 10.83 12.9419C11.2796 12.9419 11.66 13.3223 11.66 13.7719L11.6599 28.5374H29.5376V10.6597L10.8299 10.6596C10.3803 10.6596 10 10.2792 10 9.82963C10 9.38004 10.3803 8.99969 10.8299 8.99969H30.3675C30.8171 8.99969 31.1974 9.38004 31.1974 9.82963L31.1973 29.3672C31.1628 29.8513 30.817 30.1971 30.3328 30.1971L30.333 30.1973Z",
    fill: "#2F8AF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableIcon);
export default __webpack_public_path__ + "static/media/disable_icon.a810b6698344db604d8311fb15ad62ef.svg";
export { ForwardRef as ReactComponent };